// extracted by mini-css-extract-plugin
module.exports = {"ul":"RichText_ul__CGscL","li":"RichText_li__h4Su7","indexItalic":"RichText_indexItalic__8kfPi"};